import React, { Component } from 'react';
import XLSX from 'xlsx';
import { message } from 'antd';
import { makeCols } from './MakeColumns';
import { SheetJSFT } from './types';
import {post} from '../../../../utility/via-fetch';

class VehicleExcelReader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: {},
      data: [],
      cols: [],
      loadStop: true
    };
    this.handleFile = this.handleFile.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const { files } = e.target;
    if (files && files[0]) this.setState({ file: files[0], loadStop: false });
  }

  handleFile() {
    /* Boilerplate to set up FileReader */
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;

    reader.onload = async (e) => {
      try {
        let rowCount = 0;
        /* Parse data */
        const bstr = e.target.result;
        const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA: true });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const data = XLSX.utils.sheet_to_json(ws);
        /* Update state */
        await this.setState({ data, cols: makeCols(ws['!ref']) }, () => {
          try {
            if (this.state.data) {
              rowCount = this.state.data.length;
              this.state.data.forEach( async(row) => {
                const car = {
                  ...row,
                  modelTypeCode: Number(row.modelTypeCode),
                  lastOdoReading: Number(row.lastOdoReading),
                  vehicleDiagramCode: Number(row.vehicleDiagramCode),
                };
                try {
                  const carId = await post('/api/vehicles', {}, car);
                  // eslint-disable-next-line no-console
                  console.log(`Vehicle created with ID: ${carId}`, car);
                } catch (err) {
                  // eslint-disable-next-line no-console
                  console.error(err);
                }
              });
            }
          } catch(er) {
            throw(er);
          }
        });
        message.info(`${rowCount} vehicles being processed - see browser console for details`, 5);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        message.error('Error loading file - see browser console for more.', 5);
      }
    };

    if (rABS) {
      reader.readAsBinaryString(this.state.file);
    } else {
      reader.readAsArrayBuffer(this.state.file);
    }
  }

  render() {
    return (
      <div>
        <p>&nbsp;</p>
        <label htmlFor="fileId">Upload an Excel file to add multiple vehicles</label>
        <br />
        <input id="fileId" type="file" className="form-control" accept={SheetJSFT} onChange={this.handleChange} />
        <br /><br />
        <input
          type="submit"
          value="Process Load"
          onClick={this.handleFile}
          disabled={this.state.loadStop}
        />
      </div>

    );
  }
}

export default VehicleExcelReader;
